var $4f461eb266a95c10$exports = {};
$4f461eb266a95c10$exports = {
  "alpha": "Alfa",
  "black": "preto",
  "blue": "Azul",
  "blue purple": "azul-p\xFArpura",
  "brightness": "Luminosidade",
  "brown": "castanho",
  "brown yellow": "amarelo-castanho",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "ciano",
  "cyan blue": "azul-ciano",
  "dark": "escuro",
  "gray": "cinzento",
  "grayish": "acinzentado",
  "green": "Verde",
  "green cyan": "verde-ciano",
  "hue": "Tonalidade",
  "light": "claro",
  "lightness": "Claridade",
  "magenta": "magenta",
  "magenta pink": "rosa-magenta",
  "orange": "laranja",
  "orange yellow": "amarelo-laranja",
  "pale": "p\xE1lido",
  "pink": "cor-de-rosa",
  "pink red": "vermelho-rosa",
  "purple": "p\xFArpura",
  "purple magenta": "p\xFArpura-magenta",
  "red": "Vermelho",
  "red orange": "laranja-vermelho",
  "saturation": "Satura\xE7\xE3o",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " transparente");
  },
  "very dark": "muito escuro",
  "very light": "muito claro",
  "vibrant": "vibrante",
  "white": "branco",
  "yellow": "amarelo",
  "yellow green": "verde-amarelo"
};
export { $4f461eb266a95c10$exports as default };